// extracted by css-extract-rspack-plugin
export default {"newTokenDisplay":"VxfMlPge1zQ4LocE","tokenLabel":"Oe3a8uOKzQe5nNaM","confirmButton":"Fs68a2wJ0cEmSkR9","flexRow":"jS48Bxu8VncZfb_t"};